import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';

export const materialSerialNumberUiNodeSpec: NodeSpec<NodeCfg<'materialSerialNumber'>> = {
    cfg: () => ({ id: getUID(), kind: 'materialSerialNumber' }),
    controls: () => ({}),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material ID' },
    }),
    nodeCategory: 'material',
    kindLabel: 'Material Serial Number',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        serialNumber: { socket: 'string', label: 'Serial Number' },
    }),
    requiredSockets: [ 'materialId', 'trigger', 'next' ],
    validator: () => true,
};
